import Vue from 'vue'
import consts from '@/consts'
import {createActionHelpers} from 'vuex-loading'
import i18n from '@/translator'

const {startLoading, endLoading} = createActionHelpers({
  moduleName: 'loading'
})

const initialStates = function () {
  return {
    isPlaying: false,
    currentTrack: Object,
    index: 0,
    playlist: [],
    isPlayingPrevious: false,
    isUnauthorized: false,
    isShareTrack: false,
    minTrackDuration: 0
  }
}

const mutations = {
  setCurrentTrackLike (state, value) {
    state.currentTrack.is_liked = value
  },
  setPlaying (state, value) {
    state.isPlaying = value
  },
  setPlaylist (state, value) {
    // Keep clone of playlist, preventing dual modifications.
    console.log('setPlaylist (state, value) { ', value)
    console.log('value.slice() ', value.slice())
    state.playlist = value.slice()
  },
  playFirstTrack (state) {
    if (state.playlist.length > 0) {
      state.currentTrack = state.playlist[0]
      console.log('state.currentTrack', state.currentTrack)
      state.isPlaying = true
      state.index = 0
    }
  },
  playNext (state) {
    if (state.index !== -1 && state.index < (state.playlist.length - 1)) {
      state.index++
      state.currentTrack = state.playlist[state.index]
      state.isPlaying = !state.isUnauthorized
    }
  },
  playPrevious (state) {
    if (state.index !== -1 && state.index > 0) {
      state.index--
      state.currentTrack = state.playlist[state.index]
      if (state.currentTrack.isAd) {
        state.isPlayingPrevious = true
      } else {
        state.isPlayingPrevious = false
      }
      state.isPlaying = !state.isUnauthorized
    }
  },
  playByIndex (state, value) {
    if (value <= 0 && value < (state.playlist.length - 1)) {
      state.index = value
      state.currentTrack = state.playlist[value]
      state.isPlaying = !state.isUnauthorized
    }
  },
  playByTrack (state, value) {
    state.index = state.playlist.indexOf(value)
    if (state.index !== -1) {
      state.currentTrack = state.playlist[state.index]
      state.isPlaying = !state.isUnauthorized
    }
  },
  addToQueue (state, value) {
    let index = state.playlist.indexOf(value[0])
    if (index === -1) {
      for (var i = 0; i < value.length; i++) {
        state.playlist.push(value[i])
      }
    }
  },
  removeAds (state) {
    for (var i = 0; i < state.playlist.length; i++) {
      if (state.playlist[i].isAd) {
        state.playlist.splice(i, 1)
      }
    }
    state.index = state.playlist.indexOf(state.currentTrack)
  },
  addAds (state, ads) {
    var aux = []
    for (var i = 0; i < state.playlist.length; i++) {
      aux.push(state.playlist[i])
      aux.push(ads[i % ads.length])
    }
    state.playlist = aux.slice()
    state.index = state.playlist.indexOf(state.currentTrack)
  },
  setIsShareTrack (state, value) {
    console.log('state.isPlaying ', state.isPlaying)
    console.log('state.currentTrack ', Object.entries(state.currentTrack))
    state.isShareTrack = value
  },
  setIsUnauthorized (state, value) {
    state.isUnauthorized = value
  },
  setMinTrackDuration (state, value) {
    state.minTrackDuration = value
  }
}
const actions = {
  setCurrentTrackLike ({commit}, value) {
    commit('setCurrentTrackLike', value)
  },
  setPlaying ({commit}, value) {
    commit('setPlaying', value)
  },
  setPlaylist ({commit, state, rootGetters}, value) {
    if (!rootGetters['user/isSubscribed']) {
      if (!state.currentTrack.isAd) {
        commit('setPlaylist', value)
        commit('addAds', rootGetters['track/ads'])
      }
    } else {
      commit('setPlaylist', value)
    }
  },
  playNext ({commit, rootGetters, state}) {
    commit('playNext')
  },
  playPrevious ({commit, rootGetters, state}) {
    commit('playPrevious')
  },
  playByIndex ({commit, rootGetters, state}, value) {
    if (!state.currentTrack.isAd) {
      commit('playByIndex', value)
    }
  },
  changeTrack ({commit, rootGetters, state}, value) {
    if (rootGetters['user/isSubscribed'] || !state.currentTrack.isAd) {
      commit('playByTrack', value)
    }
  },
  playFirstTrack ({commit, rootGetters, state}) {
    if (rootGetters['user/isSubscribed'] || !state.currentTrack.isAd) {
      commit('playFirstTrack')
    }
  },
  addToQueue ({commit, rootGetters}, value) {
    var aux = []
    aux.push(value)
    if (!rootGetters['user/isSubscribed']) {
      aux.push(rootGetters['track/ads'][Math.floor(Math.random() * rootGetters['track/ads'].length)])
    }
    commit('addToQueue', aux)
  },
  removeAdsFromCurrentPlaylist ({commit, state}) {
    if (state.currentTrack.isAd) {
      if (state.isPlayingPrevious) {
        commit('playPrevious')
      } else {
        commit('playNext')
      }
    }
    commit('removeAds')
  },
  addAdsToCurrentPlaylist ({commit, rootGetters}) {
    commit('addAds', rootGetters['track/ads'])
  },
  setIsShareTrack ({commit}, value) {
    commit('setIsShareTrack', value)
  },
  setIsUnauthorized ({commit}, value) {
    commit('setIsUnauthorized', value)
  },
  getMinTrackDuration ({commit, dispatch}) {
    startLoading(dispatch, 'player getMinTrackDuration')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/config/getValueByParameter?parameter=minTrackDuration').then(
        function (response) {
          commit('setMinTrackDuration', parseInt(response.body.data))
          if (response.body.status === true) {
            resolve(parseInt(response.body.data))
          } else {
            reject(new Error(response.body.error))
          }
          endLoading(dispatch, 'player getMinTrackDuration')
        },
        function () {
          endLoading(dispatch, 'player getMinTrackDuration')
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  }
}

const getters = {
  isPlaying: state => {
    return state.isPlaying
  },
  isCurrentTrack: (state) => (track) => {
    return state.currentTrack === track
  },
  currentTrack: state => {
    return state.currentTrack
  },
  playlist: state => {
    return state.playlist
  },
  canPrevious: state => {
    let index = state.playlist.indexOf(state.currentTrack)
    return ((index !== -1 && index > 0) && !state.currentTrack.isAd)
  },
  canNext: state => {
    let index = state.playlist.indexOf(state.currentTrack)
    return ((index !== -1 && index < (state.playlist.length - 1)) && !state.currentTrack.isAd)
  },
  currentIndex: state => {
    return state.index
  },
  isPlayingPrevious: state => {
    return state.isPlayingPrevious
  },
  isShareTrack: state => {
    return state.isShareTrack
  },
  isUnauthorized: state => {
    return state.isUnauthorized
  },
  minTrackDuration: state => {
    return state.minTrackDuration
  }
}

const player = {
  namespaced: true,
  initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
}

export default player



// WEBPACK FOOTER //
// ./src/store/modules/player.js